import './MyWorks.scss';
import React, { useContext, useEffect, useState } from "react";
import Book from '../../components/Book/Book';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import AuthContext from "../../context/AuthContext";
import SnackbarContext from "../../context/SnackbarContext";
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import { authHeaders } from '../../utils/api';

export default function MyWorks() {

    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const { authTokens } = useContext(AuthContext);
    const { setSnackbar } = useContext(SnackbarContext);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/books/show-books/`, {
                    headers: authHeaders(authTokens),
                });
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                const data = await r.json();
                if (!cancelled) setBooks(data.books ?? []);
            } catch (err) {
                if (!cancelled) {
                    setSnackbar({ content: 'تعذر تحميل الكتب', success: false });
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [authTokens, setSnackbar]);

    return (
        <>
        <Navbar />
        <main className='mw-page'>
            <div className='mw-container'>
                <div className='mw-header-row'>
                    <h1 className='mw-header'>كتبي</h1>
                    <Link to='/writing' className='mw-new-book'>+ كتاب جديد</Link>
                </div>

                {loading ? (
                    <p className='mw-empty'>جارٍ التحميل…</p>
                ) : books.length === 0 ? (
                    <div className='mw-empty-state'>
                        <p>لم تكتب أي كتاب بعد.</p>
                        <Link to='/writing' className='mw-new-book'>ابدأ الكتابة</Link>
                    </div>
                ) : (
                    <div className='mw-books-grid'>
                        {books.map(book => (
                            <Book
                                key={book.id}
                                id={book.id}
                                title={book.title}
                                author={book.author}
                                displayAuthor={book.display_author}
                                coverImage={book.cover_image}
                                categoryLabel={book.category_label}
                                is_published={book.is_published}
                                publishedAt={book.published_at}
                                updatedAt={book.date_modified}
                            />
                        ))}
                    </div>
                )}
            </div>
        </main>
        <Footer />
        </>
    );
}
